import * as React from 'react';
import { InputText, InputTextProps } from 'primereact/inputtext';
import clsx from 'clsx';
import styles from './NewInput.module.css';

export const NewInput: React.FC<InputTextProps> = ({ className, ...props }) => (
  <InputText
    className={clsx(styles.input, className)}
    {...props}
  />
);
